import React, { Component } from "react";

import { Form, Button, Input, Row, Col, Spin, Modal, Select, Checkbox, Upload, DatePicker } from "antd";
import config from "../config";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";

import CompanyStore from "../store/CompanyStore";
import { UploadOutlined } from "@ant-design/icons";
import TicketStore from "../store/TicketStore";
import VehicleStore from "../store/VehicleStore";
import VehicleWorkingHoursStore from "../store/VehicleWorkingHoursStore";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import axios from "axios";
import Cookies from "universal-cookie";
import dayjs from "dayjs";
const { Option } = Select;
class TicketAdd extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            show: false,
            ticketId: -1,
            companyId: "",
            loadingSpin: false,
            disabledSaveButton: false,
            waslRegistration: false,
            showVehicleDropdown: false,
            loadData: 1,
            priorityValue: null,
            ticketStatus: 1,
            invoice: '',
            hideFields: true,
            existingIssueRequiredFields: true,
            disabledFields: false
        };

        this.ticketStore = new TicketStore(this)
        this.companyStore = new CompanyStore(this);
        this.vehicleStore = new VehicleStore(this)
        this.workingHoursStore = new VehicleWorkingHoursStore(this)
        this.cookies = new Cookies();

    }

    async componentDidMount() {
        let tokendata = this.cookies.get("data")
            ? JSON.parse(base64_decode(this.cookies.get("data")))
            : "";
        const userToken = tokendata.userToken;

        this.setState({ token: userToken });
        if (Number(this.props.getUserData().isadmin) !== -1 || Number(this.props.getUserData().isadmin) !== 3) {
            await this.vehicleStore.getVehiclesCompanyId(this.props.getUserData().userCompanyId)
            await this.workingHoursStore.getVehicleGroup({
                companyId: this.props.getUserData().userCompanyId,
                userId: this.props.getUserData().userId,
                isadmin: this.props.getUserData().isadmin,
            });

            this.setState({ loadData: 1 })
        }
        const Id = this.props.ticketId;

        if (Id) {
            await this.setState({ loadingSpin: true });
            const getTicketData = await this.ticketStore.getTicketDetails({ ticketId: Id });
            await this.setState({
                ticketId: getTicketData.ticketId,
            });

            this.formRef.current.setFieldsValue({
                ticketType: getTicketData.ticketType,
                chassisNo: getTicketData.chassisNumber,
                comment: getTicketData.comment,
                date: getTicketData?.date
                    ? dayjs(getTicketData.date)
                    : null,
                groupId: getTicketData.groupId,
                location: getTicketData.installedLocation,
                make: getTicketData.make,
                vehicleModel: getTicketData.model,
                plateNumber: getTicketData.plateNumber,
                plateType: getTicketData.plateType,
                plateTypeActivity: getTicketData.plateTypeActivity,
                priority: getTicketData.priority,
                sequenceNo: getTicketData.sequenceNo,
                vehicleId: getTicketData.vehicleId,
                ticketStatus: getTicketData.ticketStatus,
                actionTaken: getTicketData.actionTaken,
                invoice: getTicketData.docs
            });

            if (getTicketData.waslIntegration) {
                this.setState({ waslRegistration: true })
            }

            if (getTicketData.ticketType == 1) {
                this.setState({ showVehicleDropdown: true, existingIssueRequiredFields: false })
            }
            await this.setState({ invoice: getTicketData.docs, loadingSpin: false, ticketStatus: getTicketData.ticketStatus, });

            if (Number(this.props.getUserData().isadmin) == -1 || Number(this.props.getUserData().isadmin) == 3) {
                this.setState({ disabledFields: true })
            }

        }
    }
    async handleSearch() {
        const isadmin = this.props.getUserData().isadmin
        const usercompanyId = this.props.getUserData().userCompanyId
        const addedByUserId = this.props.getUserData().userId
        await this.ticketStore.getTicketData({
            isadmin: isadmin,
            usercompanyId: usercompanyId,
            addedByUserId: addedByUserId,
            offset: 0,
            limit: 50,
        });
        await this.setState({ loadData: 1 });
    }

    onTicketDetailsSubmit = async (values) => {
        this.setState({ loading: true })
        const TicketDetails = {
            ...values,
            ticketId: this.state.ticketId,
            priorityValue: this.state.priorityValue,
            addedByUserId: this.props.getUserData().userId,
            // date: values?.date
            //     ? values?.date?.format("YYYY-MM-DD")
            //     : null,
            date: dayjs().format("YYYY-MM-DD"),
            addedByDate: dayjs().format("YYYY-MM-DD"),
            waslIntegration: this.state.waslRegistration ? 1 : 0,
            docs: this.state.invoice,
            ticketStatus: this.state.ticketStatus
        };
        const response = await this.ticketStore.addData(TicketDetails);
        this.props.response(response);
        // await this.handleSearch();

        this.setState({ loading: false, loadData: 1 });
    };

    closeModal = () => {
        this.props.closeModal();
    };

    getUploadData = async (fileUp) => {
        let fileinfo = fileUp.file.response;
        if (fileinfo?.success == "S") {
            await this.setState({ invoice: fileinfo.data });
        }
        fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
        this.ticketStore.setPhotoFromDb(fileUp.fileList);
        this.setState({ update: 1 });
    };

    uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
        try {
            const formData = new FormData();
            formData.append("invoice", file);
            formData.append("fileType", "invoice");
            formData.append("fieldName", "invoice");

            const response = await axios.post(
                // config.baseURL + this.companyStore.fileUploadUrl,
                config.NodeUrl + "/ticket/fileUpload",
                formData,
                {
                    headers: {
                        token: this.state.token,
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (event) => {
                        const percent = Math.round((event.loaded * 100) / event.total);
                        onProgress({ percent });
                    },
                }
            );

            onSuccess(response.data);
        } catch (error) {
            onError(error);
        }
    };


    render() {

        const isadminCondition = Number(this.props.getUserData().isadmin) !== -1 && Number(this.props.getUserData().isadmin) !== 3
        return (
            <div style={{ padding: 0, height: "100%" }}>
                <div style={{ paddingBottom: "10px", height: "100%" }}>
                    <Spin
                        wrapperClassName="spinClass"
                        spinning={this.state.loadingSpin}
                        fullscreen
                    >
                        <Form
                            layout="vertical"
                            onFinish={this.onTicketDetailsSubmit}
                            name="nest-message"
                            ref={this.formRef}
                            className="formClass"
                            initialValues={{ ticketStatus: 1 }}
                        >

                            <Row className="overflowFormInputs">
                                <Col span={12} className="formColumnClass">
                                    <Form.Item
                                        name="ticketType"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_TICKET_TYPE_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_TICKET_TYPE_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Select
                                            disabled={this.state.disabledFields}
                                            options={[
                                                { label: this.context.translate("_EXISTING_VEHICLE_"), value: 1 },
                                                { label: this.context.translate("_NEW_INSTALLATION_"), value: 2 },
                                            ]}
                                            onSelect={(val) => {
                                                if (val === 1) {
                                                    this.setState({ showVehicleDropdown: true, hideFields: false, existingIssueRequiredFields: false })

                                                } else {
                                                    this.formRef.current.setFieldsValue({
                                                        chassisNo: undefined,
                                                        plateNumber: undefined,
                                                        model: undefined,
                                                        make: undefined
                                                    });
                                                    this.setState({ showVehicleDropdown: false, hideFields: true, existingIssueRequiredFields: true })
                                                }
                                            }}
                                        />
                                    </Form.Item>

                                    {this.state.showVehicleDropdown && <Form.Item
                                        name="vehicleId"
                                        label={
                                            <span>
                                                {this.context.translate("_VEHICLES_")}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_VEHICLES_"
                                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                                            },
                                        ]}
                                    >
                                        <Select
                                            disabled={this.state.disabledFields}
                                            className="select-dropdown"
                                            // mode="multiple"
                                            // maxTagCount={"responsive"}
                                            placeholder={this.context.translate(
                                                "_PLEASE_SELECT_VEHICLES_"
                                            )}
                                            showSearch
                                            onChange={(val, option) => {
                                                const record = option.record;

                                                this.formRef.current.setFieldsValue({
                                                    chassisNo: record.vin,
                                                    plateNumber: record.vehicleNo,
                                                    model: record.model,
                                                    make: record.vehicleBrand
                                                });
                                            }}

                                            filterOption={(inputValue, option) => {
                                                if (option.children) {
                                                    return (
                                                        option.children
                                                            .toLowerCase()
                                                            .indexOf(inputValue.toLowerCase()) >= 0
                                                    );
                                                }
                                            }}
                                        >
                                            {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                                                return (
                                                    <Option key={val.vehicleId} record={val} value={val.vehicleId}>{val.vehicleNo}</Option>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>}
                                    <Form.Item
                                        name="chassisNo"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_CHASSIS_NUMBER_"
                                                )}{" "}
                                                {this.state.existingIssueRequiredFields && (
                                                    <span style={{ color: "red" }}>*</span>
                                                )}

                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: this.state.existingIssueRequiredFields,
                                                message: `${this.context.translate(
                                                    "_CHASSIS_NUMBER_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>

                                    {/* <Form.Item
                                        name="date"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_DATE_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_DATE_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <DatePicker style={{ width: "100%", height: "40px" }} />
                                    </Form.Item> */}


                                    <Form.Item
                                        name="make"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_MAKE_"
                                                )}{" "}
                                                {this.state.existingIssueRequiredFields && (
                                                    <span style={{ color: "red" }}>*</span>
                                                )}

                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: this.state.existingIssueRequiredFields,
                                                message: `${this.context.translate(
                                                    "_MAKE_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>

                                    <Form.Item
                                        name="vehicleModel"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_VEHICLE_MODEL_"
                                                )}{" "}
                                                {this.state.existingIssueRequiredFields && (
                                                    <span style={{ color: "red" }}>*</span>
                                                )}

                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: this.state.existingIssueRequiredFields,
                                                message: `${this.context.translate(
                                                    "_VEHICLE_MODEL_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>

                                    {/* {this.state.hideFields && <Form.Item
                                        name="groupId"
                                        label={this.context.translate(
                                            "_VEHICLE_GROUPS_"
                                        )}
                                    >
                                        <Select
                                            showSearch
                                            // mode="multiple"
                                            // maxTagCount="responsive"
                                            filterOption={(inputValue, option) => {
                                                if (option.children) {
                                                    return (
                                                        option.children
                                                            .toLowerCase()
                                                            .indexOf(inputValue.toLowerCase()) >= 0
                                                    );
                                                }
                                            }}
                                            onChange={async (val) => {

                                                await this.setState({ deviceGroupId: val });

                                            }}

                                        >
                                            {this.workingHoursStore.groupList?.map((val) => {
                                                return (
                                                    <Select.Option
                                                        value={val.deviceGroupId}
                                                        key={val.deviceGroupId}
                                                    >
                                                        {this.props.getUserData().isadmin === 3
                                                            ? val.groupname
                                                            : val.text}
                                                    </Select.Option>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>
                                    } */}
                                    {!isadminCondition && <Form.Item
                                        name="ticketStatus"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_TICKET_STATUS_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_TICKET_STATUS_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Select
                                            options={[
                                                { label: this.context.translate("Open"), value: 1 },
                                                { label: this.context.translate("In Progress"), value: 2 },
                                                { label: this.context.translate("On Hold"), value: 3 },
                                                { label: this.context.translate("Resolved"), value: 4 },
                                                { label: this.context.translate("Closed"), value: 5 },
                                            ]}
                                            onSelect={(val) => {
                                                this.setState({ ticketStatus: val })
                                            }}
                                        />
                                    </Form.Item>}
                                    <Form.Item
                                        name=""
                                        label={" "}
                                    >
                                        <Upload
                                            name="invoice"
                                            // action={
                                            //     config.baseURL + "jobManagementList/uploadExcel"
                                            // }
                                            listType="picture"
                                            // data={{ fileType: "invoice", fieldName: "invoice" }}
                                            onChange={this.getUploadData}
                                            customRequest={(options) =>
                                                this.uploadFunction(options)
                                            }
                                            disabled={this.state.disabledFields}

                                            maxCount={1}
                                            onRemove={async () => {
                                                await this.ticketStore.setPhotoFromDb([]);
                                                await this.setState({ invoice: "", fileList: [] });
                                            }}

                                            {...this.ticketStore.photoFromDb}
                                        >
                                            <Button className="imgupload" icon={<UploadOutlined />}>
                                                {this.context.translate("_UPLOAD_")}
                                            </Button>
                                        </Upload>
                                    </Form.Item>
                                </Col>
                                <Col span={12} className="formColumnClass">
                                    <Form.Item
                                        name="comment"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_FLEET_CREATEROUTE_ROUTEADD_COMMENT_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_FLEET_CREATEROUTE_ROUTEADD_COMMENT_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>
                                    <Form.Item
                                        name="plateNumber"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_NUMBER_"
                                                )}{" "}
                                                {this.state.existingIssueRequiredFields && (
                                                    <span style={{ color: "red" }}>*</span>
                                                )}

                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: this.state.existingIssueRequiredFields,
                                                message: `${this.context.translate(
                                                    "_NUMBER_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>

                                    <Form.Item
                                        name="priority"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_PRIORITY_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_PRIORITY_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Select
                                            disabled={this.state.disabledFields}
                                            options={[
                                                { label: this.context.translate("Low"), value: 1 },
                                                { label: this.context.translate("Medium"), value: 2 },
                                                { label: this.context.translate("High"), value: 3 },

                                            ]}
                                            onSelect={(val) => {
                                                this.setState({ priorityValue: val })
                                            }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="plateType"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_PLATE_TYPE_"
                                                )}{" "}
                                                {/* <span style={{ color: "red" }}>*</span> */}
                                            </span>
                                        }
                                    // required={false}
                                    // rules={[
                                    //     {
                                    //         required: true,
                                    //         message: `${this.context.translate(
                                    //             "_PLATE_TYPE_"
                                    //         )} ${this.context.translate(
                                    //             "_IS_REQUIRED_"
                                    //         )}`,
                                    //     },
                                    // ]}
                                    >
                                        <Select
                                            disabled={this.state.disabledFields}
                                            options={[
                                                { label: "Private", value: "private" },
                                                { label: "Public", value: "public" },

                                            ]}
                                        // onSelect={(val) => {
                                        //     this.showPulseFields(val);
                                        // }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="location"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_VEHICLE_AVAILIBILITY_LOCATION_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_LOCATION_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>

                                    {this.state.hideFields && <Form.Item
                                        name=""
                                        label={" "}
                                    >
                                        <Checkbox
                                            disabled={this.state.disabledFields}

                                            style={{ marginTop: "10px" }} checked={this.state.waslRegistration}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    waslRegistration: e.target.checked,
                                                });
                                            }}
                                        />&nbsp;{this.context.translate("_REQUIRE_WASL_INTEGRATION_")}
                                    </Form.Item>}
                                    {this.state.waslRegistration &&

                                        <>
                                            <Form.Item
                                                name="sequenceNo"
                                                label={
                                                    <span>
                                                        {this.context.translate(
                                                            "_SEQUENCE_NUMBER_"
                                                        )}{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                required={false}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate(
                                                            "_SEQUENCE_NUMBER_"
                                                        )} ${this.context.translate(
                                                            "_IS_REQUIRED_"
                                                        )}`,
                                                    },
                                                ]}
                                            >
                                                <Input disabled={this.state.disabledFields} />
                                            </Form.Item>

                                            <Form.Item
                                                name="plateTypeActivity"
                                                label={
                                                    <span>
                                                        {this.context.translate(
                                                            "_PLATE_TYPE_ACTIVITY_"
                                                        )}{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                required={false}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate(
                                                            "_PLATE_TYPE_ACTIVITY_"
                                                        )} ${this.context.translate(
                                                            "_IS_REQUIRED_"
                                                        )}`,
                                                    },
                                                ]}
                                            >
                                                <Input disabled={this.state.disabledFields} />
                                            </Form.Item>
                                        </>
                                    }


                                    {!isadminCondition && <Form.Item
                                        name="actionTaken"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_ACTION_TAKEN_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_ACTION_TAKEN_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>}

                                </Col>
                            </Row>

                            <div className="formFooter">
                                <Button
                                    className="formsCancelButton"
                                    onClick={() => this.closeModal()}
                                >
                                    {this.context.translate(
                                        "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                    )}
                                </Button>
                                <Button
                                    htmlType="submit"
                                    className="formsSaveButton"
                                // onClick={() => this.onExcelSubmit()}
                                >
                                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                                </Button>
                            </div>
                        </Form>
                    </Spin>
                </div>
            </div>
        );
    }
}

TicketAdd.contextType = StoreContext;
export default observer(withRouter(TicketAdd));
